import { LayoutUnitThickness } from '../../models/basic/layoutunitthickness.model';
import { Alignment, FlexItemAlignment } from '../../models/enums/alignment.enum';
import { BorderStyle } from '../../models/enums/borderstyle.enum';
import { EventActionType } from '../../models/enums/eventactiontype.enum';
import { Orientation } from '../../models/enums/orientation.enum';
import { UnitType } from '../../models/enums/unittype.enum';
import { Layout } from '../../models/layout.model';
import { LayoutBase, StyleBase } from '../../models/layoutbase.model';
import { Border } from '../../models/style/border.model';
import { Color } from '../../models/style/color.model';
import { Font } from '../../models/style/font.model';
import { Gradient } from '../../models/style/gradient.model';
import { WorkflowModuleData } from '../../models/workflow/workflow.model';
import { DataSwitchSettings, DataSwitchSettingsData } from '../../workflow/modules/dataswitch/dataswitch.settings';
import { DefineMultiValuesSettingsData } from '../../workflow/modules/definevalue/define.multi.values.settings';
import { DefineValueSettings } from '../../workflow/modules/definevalue/define.value.settings';
import { ExecuteWorkflowData } from '../../workflow/modules/executeWorkflow/executeWorkflow.settings';
import { SetControlPropertiesSettings, SetControlPropertiesSettingsData } from '../../workflow/modules/layout/elemProperty/set.control.properties.settings';
import { GetMultiElemValueSettings, GetMultiElemValueSettingsData } from '../../workflow/modules/layout/elemValue/get.multi.elem.value.settings';
import { RemoveMultiStyleSettings, RemoveMultiStyleSettingsData } from '../../workflow/modules/layout/setStyle/remove.multi.style.settings';
import { SetMultiStyleSettings, SetMultiStyleSettingsData } from '../../workflow/modules/layout/setStyle/set.multi.style.settings';
import { SendPWResetMailSettings, SendPWResetMailSettingsData } from '../../workflow/modules/login/send.pw.reset.mail.settings';
import { OpenURLSettings, OpenURLSettingsData } from '../../workflow/modules/navigation/openURL.settings';
import { ReadMultiPropertySettings, ReadMultiPropertySettingsData } from '../../workflow/modules/readProperty/read.multi.property.settings';
import { LoginLayoutHelper } from './login.layout.helper';

export class ForgotPWLayoutHelper {
    static GetLayout(): Layout {
        //#region Layout
        const l = new Layout();
        l.Visible = true;
        l.Name = 'ForgotPW';
        l.BackgroundColor = Gradient.Solid(Color.FromHex('#F9FAFB'));
        l['ElementType'] = 'grid';

        const outerCol = new LayoutBase();
        outerCol.Size = LoginLayoutHelper.GetLayoutUnit(UnitType.fr, 1);
        l['ColumnDefinitions'] = [outerCol];

        const outerRow = new LayoutBase();
        outerRow.Size = LoginLayoutHelper.GetLayoutUnit(UnitType.fr, 1);
        l['RowDefinitions'] = [outerRow];

        const loading = LoginLayoutHelper.GetLayoutElement('Loading', 'loading', false);
        l.Elements.push(loading);

        const innerGrid = LoginLayoutHelper.GetLayoutElement('InnerGrid', 'grid');

        innerGrid.Width = LoginLayoutHelper.GetLayoutUnit(UnitType.Auto, 1);
        innerGrid.Height = LoginLayoutHelper.GetLayoutUnit(UnitType.Auto, 1);
        innerGrid.HorizontalContentAlignment = Alignment.Center;
        innerGrid.VerticalContentAlignment = Alignment.Center;
        innerGrid.BackgroundColor = Gradient.Solid(Color.FromHex('#FFFFFF'));
        innerGrid.Border = new Border();
        innerGrid['UseBorder'] = true;
        LoginLayoutHelper.SetBorderRadius(innerGrid.Border, 12);
        innerGrid.Font = new Font();
        innerGrid.Font.FontColor = Color.FromHex('#334155');
        innerGrid.Padding = new LayoutUnitThickness();
        innerGrid.Padding.Left = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 24);
        innerGrid.Padding.Right = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 24);
        innerGrid.Padding.Top = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 30);
        innerGrid.Padding.Bottom = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 30);
        innerGrid['UseDecorationsOnLayout'] = true;
        innerGrid['DropShadow'] = true;
        innerGrid['BoxShadow'] = [{
            "Color": "#000000",
            "ShiftRight": 0,
            "ShiftDown": 3,
            "Blur": 16,
            "Spread": 0,
            "Opacity": 0.16
        }];

        const innerFirstCol = new LayoutBase();
        innerFirstCol.Size = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 370);
        innerGrid['ColumnDefinitions'] = [innerFirstCol];

        let rowIndex = 1;

        const headerFlex = LoginLayoutHelper.GetLayoutElement('HeaderFlex', 'flex');
        headerFlex.Row = rowIndex++;
        headerFlex['Orientation'] = Orientation.Horizontal;
        headerFlex['FlexAlignItems'] = FlexItemAlignment.center;
        headerFlex.Margin = new LayoutUnitThickness();
        headerFlex.Margin.Bottom = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 12);

        const backIcon = LoginLayoutHelper.GetLayoutElement('BackIcon', 'icon');
        backIcon['Icon'] = 'arrow_back';
        backIcon['IconHeight'] = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 21);
        backIcon['IconWidth'] = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 21);
        backIcon.Margin = new LayoutUnitThickness();
        backIcon.Margin.Top = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 2);
        backIcon.Margin.Right = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 4);
        headerFlex.Elements.push(backIcon);

        const resetHeader = LoginLayoutHelper.GetLayoutElement('ResetHeader', 'textblock');
        resetHeader.Caption = '@@ResetPW';
        resetHeader.Font = new Font();
        resetHeader.Font.FontSize = 14;
        headerFlex.Elements.push(resetHeader);

        innerGrid.Elements.push(headerFlex);

        const resetDesc = LoginLayoutHelper.GetLayoutElement('ResetDescription', 'textblock');
        resetDesc.Row = rowIndex++;
        resetDesc.Caption = '@@ResetPWInfo';
        resetDesc.Font = new Font();
        resetDesc.Font.FontSize = 11;
        resetDesc.Padding = new LayoutUnitThickness();
        resetDesc.Padding.Bottom = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 16);
        innerGrid.Elements.push(resetDesc);

        const mailGrid = LoginLayoutHelper.GetLayoutElement('MailGrid', 'grid');
        mailGrid.Row = rowIndex++;
        const mailGridCol = new LayoutBase();
        mailGridCol.Size = LoginLayoutHelper.GetLayoutUnit(UnitType.fr, 1);
        mailGrid['ColumnDefinitions'] = [mailGridCol];
        const mailGridFirstRow = new LayoutBase();
        mailGridFirstRow.Size = LoginLayoutHelper.GetLayoutUnit(UnitType.Auto, 1);
        const mailGridSecondRow = new LayoutBase();
        mailGridSecondRow.Size = LoginLayoutHelper.GetLayoutUnit(UnitType.Auto, 1);
        mailGrid['RowDefinitions'] = [mailGridFirstRow, mailGridSecondRow];

        const mailHeader = LoginLayoutHelper.GetLayoutElement('MailHeader', 'textblock');
        mailHeader.Caption = '@@EmailAddress';
        mailHeader.Font = new Font();
        mailHeader.Font.FontSize = 8;
        mailHeader.Padding = new LayoutUnitThickness();
        mailHeader.Padding.Bottom = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 4);
        mailGrid.Elements.push(mailHeader);

        const mailTB = LoginLayoutHelper.GetLayoutElement('MailTB', 'textbox');
        mailTB.Row = 2;
        mailTB.Editable = true;
        mailGrid.Elements.push(mailTB);

        innerGrid.Elements.push(mailGrid);

        const successGrid = LoginLayoutHelper.GetLoginGrid('SuccessGrid', rowIndex);
        successGrid.Visible = false;
        LoginLayoutHelper.SetBorder(successGrid, 1, BorderStyle.Solid, '#bbf7d0');
        LoginLayoutHelper.SetBorderRadius(successGrid.Border, 6);
        successGrid.BackgroundColor = Gradient.Solid(Color.FromHex('#f0fdf4f2'));
        successGrid.Padding = new LayoutUnitThickness();
        successGrid.Padding.Bottom = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 16);

        const successHeader = LoginLayoutHelper.GetLayoutElement('SuccessHeader', 'textblock');
        successHeader.Column = 2;
        successHeader.Caption = '@@PWResetMailSent';
        successHeader.Font = new Font();
        successHeader.Font.FontColor = Color.FromHex('#16a34a');
        successHeader.Font.FontSize = 11;
        successHeader.Padding = new LayoutUnitThickness();
        successHeader.Padding.Top = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 10);
        successHeader.Padding.Bottom = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 7);
        successGrid.Elements.push(successHeader);

        const successIcon = LoginLayoutHelper.GetLayoutElement('SuccessIcon', 'icon');
        successIcon.VerticalContentAlignment = Alignment.Center;
        successIcon['Icon'] = 'checkbox';
        successIcon.Font = new Font();
        successIcon.Font.FontColor = Color.FromHex('#16a34a');
        successIcon.Padding = new LayoutUnitThickness();
        successIcon.Padding.Left = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 6);
        successIcon.Padding.Top = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 6);
        successIcon.Padding.Right = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 4);
        successGrid.Elements.push(successIcon);

        const successText = LoginLayoutHelper.GetLayoutElement('SuccessText', 'textblock');
        successText.Row = 2;
        successText.Column = 2;
        successText.Caption = '@@PWResetEmailInfo';
        successText.Font = new Font();
        successText.Font.FontSize = 9;
        successText.Padding = new LayoutUnitThickness();
        successText.Padding.Bottom = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 10);
        successGrid.Elements.push(successText);

        innerGrid.Elements.push(successGrid);

        const errorGrid = LoginLayoutHelper.GetLoginGrid('ErrorGrid', rowIndex++);
        errorGrid.Visible = false;
        LoginLayoutHelper.SetBorder(errorGrid, 1, BorderStyle.Solid, '#fecaca');
        LoginLayoutHelper.SetBorderRadius(errorGrid.Border, 6);
        errorGrid.BackgroundColor = Gradient.Solid(Color.FromHex('#fef2f2f2'));
        errorGrid.Padding = new LayoutUnitThickness();
        errorGrid.Padding.Bottom = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 16);

        const errorHeader = LoginLayoutHelper.GetLayoutElement('ErrorHeader', 'textblock');
        errorHeader.Column = 2;
        errorHeader.Caption = '@@PWResetMailError';
        errorHeader.Font = new Font();
        errorHeader.Font.FontColor = Color.FromHex('#dc2626');
        errorHeader.Font.FontSize = 11;
        errorHeader.Padding = new LayoutUnitThickness();
        errorHeader.Padding.Top = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 10);
        errorHeader.Padding.Bottom = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 7);
        errorGrid.Elements.push(errorHeader);

        const errorIcon = LoginLayoutHelper.GetLayoutElement('ErrorIcon', 'icon');
        errorIcon.VerticalContentAlignment = Alignment.Center;
        errorIcon['Icon'] = 'cancel';
        errorIcon.Font = new Font();
        errorIcon.Font.FontColor = Color.FromHex('#dc2626');
        errorIcon.Padding = new LayoutUnitThickness();
        errorIcon.Padding.Left = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 6);
        errorIcon.Padding.Top = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 6);
        errorIcon.Padding.Right = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 4);
        errorGrid.Elements.push(errorIcon);

        const errorText = LoginLayoutHelper.GetLayoutElement('ErrorSubText', 'textblock');
        errorText.Row = 2;
        errorText.Column = 2;
        errorText.Caption = '@@PWResetMailErrorInfo';
        errorText.Font = new Font();
        errorText.Font.FontSize = 9;
        errorText.Padding = new LayoutUnitThickness();
        errorText.Padding.Bottom = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 10);
        errorGrid.Elements.push(errorText);

        innerGrid.Elements.push(errorGrid);

        const buttonGrid = LoginLayoutHelper.GetLayoutElement('ButtonGrid', 'grid');
        buttonGrid.Row = rowIndex++;
        buttonGrid.Editable = true;
        const bgFirstCol = new LayoutBase();
        bgFirstCol.Size = LoginLayoutHelper.GetLayoutUnit(UnitType.fr, 1);
        const bgSecondCol = new LayoutBase();
        bgSecondCol.Size = LoginLayoutHelper.GetLayoutUnit(UnitType.Auto, 1);
        const bgThirdCol = new LayoutBase();
        bgThirdCol.Size = LoginLayoutHelper.GetLayoutUnit(UnitType.Auto, 1);
        const bgFourthCol = new LayoutBase();
        bgFourthCol.Size = LoginLayoutHelper.GetLayoutUnit(UnitType.fr, 1);
        buttonGrid['ColumnDefinitions'] = [bgFirstCol, bgSecondCol, bgThirdCol, bgFourthCol];
        const bgRow = new LayoutBase();
        bgRow.Size = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 36);
        buttonGrid['RowDefinitions'] = [bgRow];
        buttonGrid.Font = new Font();
        buttonGrid.Font.FontColor = Color.FromHex('#113342');
        buttonGrid.Border = new Border();
        LoginLayoutHelper.SetBorderRadius(buttonGrid.Border, 6);
        buttonGrid.BackgroundColor = Gradient.Solid(Color.FromHex('#2bee82'));
        buttonGrid['Cursor'] = 'pointer';

        const mailIcon = LoginLayoutHelper.GetLayoutElement('MailIcon', 'icon');
        mailIcon.Column = 2;
        mailIcon['Icon'] = 'mail';
        mailIcon['IconHeight'] = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 17);
        mailIcon['IconWidth'] = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 17);
        mailIcon.VerticalTextAlignment = Alignment.Center;
        mailIcon.Margin = new LayoutUnitThickness();
        mailIcon.Margin.Top = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 1);
        buttonGrid.Elements.push(mailIcon);

        const sendMailTB = LoginLayoutHelper.GetLayoutElement('SendMailTB', 'textblock');
        sendMailTB.Column = 3;
        sendMailTB.Font = new Font();
        sendMailTB.Font.FontSize = 11;
        sendMailTB.Caption = '@@SendResetMail';
        sendMailTB.Padding = new LayoutUnitThickness();
        sendMailTB.Padding.Left = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 6);
        sendMailTB.VerticalTextAlignment = Alignment.Center;
        buttonGrid.Elements.push(sendMailTB);

        innerGrid.Elements.push(buttonGrid);

        const backGrid = LoginLayoutHelper.GetLayoutElement('BackGrid', 'grid');
        backGrid.Row = rowIndex;
        const backFirstCol = new LayoutBase();
        backFirstCol.Size = LoginLayoutHelper.GetLayoutUnit(UnitType.fr, 1);
        const backSecondCol = new LayoutBase();
        backSecondCol.Size = LoginLayoutHelper.GetLayoutUnit(UnitType.Auto, 1);
        const backThirdCol = new LayoutBase();
        backThirdCol.Size = LoginLayoutHelper.GetLayoutUnit(UnitType.Auto, 1);
        const backFourthCol = new LayoutBase();
        backFourthCol.Size = LoginLayoutHelper.GetLayoutUnit(UnitType.fr, 1);
        backGrid['ColumnDefinitions'] = [backFirstCol, backSecondCol, backThirdCol, backFourthCol];
        const backRow = new LayoutBase();
        backRow.Size = LoginLayoutHelper.GetLayoutUnit(UnitType.fr, 1);
        backGrid['RowDefinitions'] = [backRow];
        backGrid.Padding = new LayoutUnitThickness();
        backGrid.Padding.Top = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 16);

        const backText = LoginLayoutHelper.GetLayoutElement('BackText', 'textblock');
        backText.Column = 2;
        backText.Caption = '@@RememberPW';
        backText.Font = new Font();
        backText.Font.FontSize = 11;
        backText.Margin = new LayoutUnitThickness();
        backText.Margin.Right = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 6);
        backGrid.Elements.push(backText);

        const backLink = LoginLayoutHelper.GetLayoutElement('BackLink', 'textblock');
        backLink.Editable = true;
        backLink.Column = 3;
        backLink.Caption = '@@BackToLogin';
        backLink.Font = new Font();
        backLink.Font.FontColor = Color.FromHex('#3b82f6');
        backLink.Font.FontSize = 11;
        backLink['Cursor'] = 'pointer';
        backGrid.Elements.push(backLink);

        innerGrid.Elements.push(backGrid);

        const innerRows = [];
        for (let i = 0; i < rowIndex; i++) {
            const innerRow = new LayoutBase();
            innerRow.Size = LoginLayoutHelper.GetLayoutUnit(UnitType.Auto, 1);
            innerRows.push(innerRow);
        }
        innerGrid['RowDefinitions'] = innerRows;

        l.Elements.push(innerGrid);
        //#endregion

        //#region Workflows
        let wfID = 0;

        //#region GoBack
        const goBackStartID = wfID++;
        const goBackWF = LoginLayoutHelper.GetWFDescription('GoBack',
            'ab14ec7f-bb59-daa1-cc3e-9e32566cc85f', goBackStartID);

        const goBackMultiValue = new DefineMultiValuesSettingsData();
        goBackMultiValue.Values.push({
            Formula: 'GenerateNull()',
            StatusKey: 'url',
            UseForState: false
        });
        const goBackMultiValueModule = LoginLayoutHelper.GetWFModule(wfID++);
        goBackMultiValueModule.Module = DefineValueSettings.MultiModuleID;
        goBackMultiValueModule.Settings = goBackMultiValue;
        goBackWF.Data.Modules.push(goBackMultiValueModule);

        const openURLData = new OpenURLSettingsData();
        openURLData.Internal = true;
        openURLData.ReadURLFromStatus = true;
        openURLData.OpenInNewWindow = false;
        openURLData.URL = 'url';
        const openURLModule = LoginLayoutHelper.GetWFModule(wfID++);
        openURLModule.Module = OpenURLSettings.ModuleID;
        openURLModule.Settings = openURLData;
        goBackWF.Data.Modules.push(openURLModule);

        goBackWF.Data.Connectors.push({
            ExitModule: goBackStartID,
            EntryModule: goBackMultiValueModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        goBackWF.Data.Connectors.push({
            ExitModule: goBackMultiValueModule.ID,
            EntryModule: openURLModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });

        l.Workflows.push(goBackWF);

        backLink.Events.push({
            EventID: 'MouseClick',
            Handlers: [
                {
                    ActionType: EventActionType.Workflow,
                    Action: goBackWF.ID
                }
            ]
        });
        //#endregion

        wfID = 0;
        //#region SendMail
        const sendMailStartID = wfID++;
        const sendMailWF = LoginLayoutHelper.GetWFDescription('SendMail',
            '56f80036-8400-6509-7eb0-6592ae28f304', sendMailStartID);

        const loadingStyle = new StyleBase();
        loadingStyle.Visible = true;
        const loadingSetStyle = new SetMultiStyleSettingsData();
        loadingSetStyle.Styles.push({
            Elements: [{ ElemName: loading.Name }],
            Layout: loadingStyle,
            StyleRef: null
        });
        const loadingSetStyleModule = ForgotPWLayoutHelper.GetWFModule(wfID++, 10, 119);
        loadingSetStyleModule.Module = SetMultiStyleSettings.ModuleID;
        loadingSetStyleModule.Settings = loadingSetStyle;
        sendMailWF.Data.Modules.push(loadingSetStyleModule);

        const setErrorCaptionData = new SetControlPropertiesSettingsData();
        setErrorCaptionData.Controls.push({
            ControlName: errorText.Name,
            Properties: [{
                Formula: 'translate("@@PWResetMailErrorInfo")',
                PropertyName: 'Caption'
            }]
        });
        const setErrorCaptionModule = ForgotPWLayoutHelper.GetWFModule(wfID++, 9, 189);
        setErrorCaptionModule.Module = SetControlPropertiesSettings.ModuleID;
        setErrorCaptionModule.Settings = setErrorCaptionData;
        sendMailWF.Data.Modules.push(setErrorCaptionModule);

        const resetResultStylesData = new RemoveMultiStyleSettingsData();
        resetResultStylesData.Elements.push({ ElemName: successGrid.Name });
        resetResultStylesData.Elements.push({ ElemName: errorGrid.Name });
        const resetResultStylesModule = ForgotPWLayoutHelper.GetWFModule(wfID++, 22, 267);
        resetResultStylesModule.Module = RemoveMultiStyleSettings.ModuleID;
        resetResultStylesModule.Settings = resetResultStylesData;
        sendMailWF.Data.Modules.push(resetResultStylesModule);

        const getMailData = new GetMultiElemValueSettingsData();
        getMailData.Elements.push({
            ElemName: mailTB.Name,
            UseForState: false,
            StatusKey: 'mailAddress'
        });
        const getMailModule = ForgotPWLayoutHelper.GetWFModule(wfID++, 19, 340);
        getMailModule.Module = GetMultiElemValueSettings.ModuleID;
        getMailModule.Settings = getMailData;
        sendMailWF.Data.Modules.push(getMailModule);

        const dataSwitchProps = new DataSwitchSettingsData();
        dataSwitchProps.Conditions.push({
            Formula: 'Or(IsNull(mailAddress); mailAddress="")',
            Name: 'isNull'
        });
        const dataSwitchModule = ForgotPWLayoutHelper.GetWFModule(wfID++, 261, 266);
        dataSwitchModule.Module = DataSwitchSettings.ModuleID;
        dataSwitchModule.Settings = dataSwitchProps;
        sendMailWF.Data.Modules.push(dataSwitchModule);

        const setErrorCaptionData2 = new SetControlPropertiesSettingsData();
        setErrorCaptionData2.Controls.push({
            ControlName: errorText.Name,
            Properties: [{
                Formula: 'translate("@@EmptyMail")',
                PropertyName: 'Caption'
            }]
        });
        const setErrorCaptionModule2 = ForgotPWLayoutHelper.GetWFModule(wfID++, 426, 345);
        setErrorCaptionModule2.Module = SetControlPropertiesSettings.ModuleID;
        setErrorCaptionModule2.Settings = setErrorCaptionData2;
        sendMailWF.Data.Modules.push(setErrorCaptionModule2);

        const sendMailData = new SendPWResetMailSettingsData();
        sendMailData.MailFormula = 'mailAddress';
        const sendMailModule = ForgotPWLayoutHelper.GetWFModule(wfID++, 220, 402);
        sendMailModule.Module = SendPWResetMailSettings.ModuleID;
        sendMailModule.Settings = sendMailData;
        sendMailWF.Data.Modules.push(sendMailModule);

        const showSuccessStyle = new StyleBase();
        showSuccessStyle.Visible = true;
        const showSuccessData = new SetMultiStyleSettingsData();
        showSuccessData.Styles.push({
            Elements: [{ ElemName: successGrid.Name }],
            Layout: showSuccessStyle,
            StyleRef: null
        });
        const showSuccessModule = ForgotPWLayoutHelper.GetWFModule(wfID++, 93, 501);
        showSuccessModule.Module = SetMultiStyleSettings.ModuleID;
        showSuccessModule.Settings = showSuccessData;
        sendMailWF.Data.Modules.push(showSuccessModule);

        const showErrorStyle = new StyleBase();
        showErrorStyle.Visible = true;
        const showErrorData = new SetMultiStyleSettingsData();
        showErrorData.Styles.push({
            Elements: [{ ElemName: errorGrid.Name }],
            Layout: showErrorStyle,
            StyleRef: null
        });
        const showErrorModule = ForgotPWLayoutHelper.GetWFModule(wfID++, 310, 504);
        showErrorModule.Module = SetMultiStyleSettings.ModuleID;
        showErrorModule.Settings = showErrorData;
        sendMailWF.Data.Modules.push(showErrorModule);

        const resetLoadingStyleData = new RemoveMultiStyleSettingsData();
        resetLoadingStyleData.Elements.push({ ElemName: loading.Name });
        const resetLoadingStyleModule = ForgotPWLayoutHelper.GetWFModule(wfID++, 280, 628);
        resetLoadingStyleModule.Module = RemoveMultiStyleSettings.ModuleID;
        resetLoadingStyleModule.Settings = resetLoadingStyleData;
        sendMailWF.Data.Modules.push(resetLoadingStyleModule);

        sendMailWF.Data.Connectors.push({
            ExitModule: sendMailStartID,
            EntryModule: loadingSetStyleModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        sendMailWF.Data.Connectors.push({
            ExitModule: loadingSetStyleModule.ID,
            EntryModule: setErrorCaptionModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        sendMailWF.Data.Connectors.push({
            ExitModule: setErrorCaptionModule.ID,
            EntryModule: resetResultStylesModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        sendMailWF.Data.Connectors.push({
            ExitModule: resetResultStylesModule.ID,
            EntryModule: getMailModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        sendMailWF.Data.Connectors.push({
            ExitModule: getMailModule.ID,
            EntryModule: dataSwitchModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        sendMailWF.Data.Connectors.push({
            ExitModule: dataSwitchModule.ID,
            EntryModule: sendMailModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        sendMailWF.Data.Connectors.push({
            ExitModule: sendMailModule.ID,
            EntryModule: showSuccessModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        sendMailWF.Data.Connectors.push({
            ExitModule: sendMailModule.ID,
            EntryModule: showErrorModule.ID,
            EntryOption: 0,
            ExitOption: -1
        });
        sendMailWF.Data.Connectors.push({
            ExitModule: showSuccessModule.ID,
            EntryModule: resetLoadingStyleModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        sendMailWF.Data.Connectors.push({
            ExitModule: showErrorModule.ID,
            EntryModule: resetLoadingStyleModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        sendMailWF.Data.Connectors.push({
            ExitModule: dataSwitchModule.ID,
            EntryModule: setErrorCaptionModule2.ID,
            EntryOption: 0,
            ExitOption: 1
        });
        sendMailWF.Data.Connectors.push({
            ExitModule: setErrorCaptionModule2.ID,
            EntryModule: showErrorModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });

        l.Workflows.push(sendMailWF);

        buttonGrid.Events.push({
            EventID: 'MouseClick',
            Handlers: [
                {
                    ActionType: EventActionType.Workflow,
                    Action: sendMailWF.ID
                }
            ]
        });
        //#endregion

        wfID = 0;
        //#region OnEnter
        const keyDownStartID = wfID++;
        const keyDownWF = LoginLayoutHelper.GetWFDescription('OnEnter',
            '937cdff9-71c9-4873-910d-b6ac1e2fd55d', keyDownStartID);

        const readProps = new ReadMultiPropertySettingsData();
        readProps.Properties.push({
            PropName: 'key',
            StatusKey: 'key',
            UseForState: false
        });
        const readPropsModule = LoginLayoutHelper.GetWFModule(wfID++);
        readPropsModule.Module = ReadMultiPropertySettings.ModuleID;
        readPropsModule.Settings = readProps;
        keyDownWF.Data.Modules.push(readPropsModule);

        const dataSwitch = new DataSwitchSettingsData();
        dataSwitch.Conditions.push({
            Name: 'Enter',
            Formula: 'key="Enter"'
        });
        const enterDataSwitchModule = LoginLayoutHelper.GetWFModule(wfID++);
        enterDataSwitchModule.Module = 'dataswitchWFModule';
        enterDataSwitchModule.Settings = dataSwitch;
        keyDownWF.Data.Modules.push(enterDataSwitchModule);

        const execWF = new ExecuteWorkflowData();
        execWF.WorkflowID = sendMailWF.ID;
        const execWFModule = LoginLayoutHelper.GetWFModule(wfID++);
        execWFModule.Module = 'execWFModule';
        execWFModule.Settings = execWF;
        keyDownWF.Data.Modules.push(execWFModule);

        const keyDownRemoveStyle = new RemoveMultiStyleSettingsData();
        keyDownRemoveStyle.Elements.push({ ElemName: errorGrid.Name });
        const keyDownRemoveStyleModule = LoginLayoutHelper.GetWFModule(wfID++);
        keyDownRemoveStyleModule.Module = RemoveMultiStyleSettings.ModuleID;
        keyDownRemoveStyleModule.Settings = keyDownRemoveStyle;
        keyDownWF.Data.Modules.push(keyDownRemoveStyleModule);

        keyDownWF.Data.Connectors.push({
            ExitModule: keyDownStartID,
            EntryModule: readPropsModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        keyDownWF.Data.Connectors.push({
            ExitModule: readPropsModule.ID,
            EntryModule: enterDataSwitchModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        keyDownWF.Data.Connectors.push({
            ExitModule: enterDataSwitchModule.ID,
            EntryModule: execWFModule.ID,
            EntryOption: 0,
            ExitOption: 1
        });
        keyDownWF.Data.Connectors.push({
            ExitModule: enterDataSwitchModule.ID,
            EntryModule: keyDownRemoveStyleModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });

        mailTB.Events.push({
            EventID: 'keydown',
            Handlers: [
                {
                    ActionType: EventActionType.Workflow,
                    Action: keyDownWF.ID
                }
            ]
        });

        l.Workflows.push(keyDownWF);
        //#endregion

        //#endregion

        return l;
    }

    static GetWFModule(id: number, x: number, y: number): WorkflowModuleData {
        const retVal = new WorkflowModuleData();
        retVal.ID = id;
        retVal.XPos = x;
        retVal.YPos = y;
        return retVal;
    }
}